<h1 mat-dialog-title>
  {{
    (data.type === 'group'
      ? 'MEETING_SCHEDULER.BOOKING_GROUP_LINK.UPDATE_PROMPT_TITLE'
      : 'MEETING_SCHEDULER.BOOKING_SERVICE_LINK.UPDATE_PROMPT_TITLE'
    ) | translate
  }}
</h1>
<div mat-dialog-content>
  <span>
    {{ 'MEETING_SCHEDULER.BOOKING_LINK.UPDATE_PROMPT_CONTENT.UPDATING_THE_LINK' | translate }}
  </span>
  <span class="original-slug">/{{ data.originalSlug }}</span>
  <span>
    {{ 'MEETING_SCHEDULER.BOOKING_LINK.UPDATE_PROMPT_CONTENT.TO' | translate }}
  </span>
  <span class="new-slug">/{{ data.newSlug }}</span>
  <span>
    {{ 'MEETING_SCHEDULER.BOOKING_LINK.UPDATE_PROMPT_CONTENT.WILL_STOP_GUESTS_FROM_BEING_ABLE_TO_BOOK' | translate }}
  </span>
  <span class="original-slug">/{{ data.originalSlug }}.</span>
  <span>
    {{ 'MEETING_SCHEDULER.BOOKING_LINK.UPDATE_PROMPT_CONTENT.DO_YOU_STILL_WANT_TO_UPDATE_THE_LINK' | translate }}
  </span>
</div>
<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="onNoClick()">
    {{
      (data.type === 'group'
        ? 'MEETING_SCHEDULER.BOOKING_GROUP_LINK.DO_NOT_UPDATE'
        : 'MEETING_SCHEDULER.BOOKING_SERVICE_LINK.DO_NOT_UPDATE'
      ) | translate
    }}
  </button>
  <button mat-raised-button color="primary" (click)="onYesClick()" cdkFocusInitial [disabled]="isUpdating">
    <glxy-button-loading-indicator [isLoading]="isUpdating">
      {{
        (data.type === 'group'
          ? 'MEETING_SCHEDULER.BOOKING_GROUP_LINK.DO_UPDATE'
          : 'MEETING_SCHEDULER.BOOKING_SERVICE_LINK.DO_UPDATE'
        ) | translate
      }}
    </glxy-button-loading-indicator>
  </button>
</mat-dialog-actions>
